<template>
    <div class="auth">
        <div class="container">
            <div class="auth--box">
                <div class="auth--box--header">
                    <h2 class="auth--title">{{$t('forget password')}}</h2>
                    <p class="auth--description">{{$t('Enter your e-mail address')}}.</p>
                </div>
                <form>
                    <div :class="{'form--group':true,'form--error':showValidMessage&&errors.has('email')}">
                        <input class="form--control" type="text" :placeholder="$t('Email')" id="email" name="email" v-model="model.email" v-validate="'required|email'" maxlength="50">
                        <p v-show="showValidMessage&&errors.has('email')" class="form--error-text">{{ errors.first('email') }}</p>
                    </div>
                    <button class="btn-round auth-btn" type="button"  @click="submit">{{$t('submit')}}</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    //import $ from 'jquery'
    import GlobalMixin from '@/GlobalMixin.js'
    import FacebookLogin from '@/components/FacebookLogin.vue'
    import LinkedinLogin from '@/components/LinkedinLogin.vue'
    import GoogleLogin from '@/components/GoogleLogin.vue'
    import { mapActions } from "vuex";

    export default {
        mixins: [GlobalMixin],
        components: { FacebookLogin, LinkedinLogin, GoogleLogin },
        data() {
            return {

            }
        },
        methods: {
            ...mapActions(["StoreUser"]),
            async submit() {
                var self = this;
                self.showValidMessage = true;
                let valid = self.customValidate();
                self.$validator.validate().then(function (result) {
                    if (!result || !valid) { ////not valid
                        let detail = $('.form--error').first()[0];
                        if (detail) {
                            detail.scrollIntoView({ behavior: 'smooth', block: 'end' });
                        }
                        return;
                    }
                    $('.form--error').removeClass("form--error");
                    self.closeErrorAlert();
                    self.ShowLoading();
                    let url = process.env.VUE_APP_APIEndPoint + 'auth/send/password-reset-email/'
                    self.axios.post(url, self.model, self.headers)
                        .then(function (res) {
                            if (res.data.success) {
                                self.model = {};                              
                                self.notify(self.$t(res.data.data.email_verification_message), "success");
                                self.$router.push({ name: 'Home' });
                            }
                            else {
                                self.notify(self.$t(res.data.Messages[0].Message), "error");
                            }
                        })
                        .catch(function (err) {
                            self.displayError(err);
                        }).finally(function () {
                            return self.HideLoading();
                        })
                })
            }

        }
    }
</script>